import { Gender } from '../../../../../../common/enums/gender';
import { coronairSclerosePercentages } from './coronairSclerosePercentages';

export function calculateCoronairSclerosePercentage(age: number, gender: Gender, numberOfIndications: number) {
    let coronairSclerosePercentage: number = 0;
    let indicationOutcomeText = '';

    if (gender !== Gender.male && gender !== Gender.female) {
        indicationOutcomeText =
            'Alleen voor een patiënt met geslacht man of vrouw kunnen we de kans op coronairsclerose bepalen';

        return { coronairSclerosePercentage, indicationOutcomeText };
    }

    if (age < 30) {
        indicationOutcomeText = 'Deze patiënt is jonger dan 30. Er is daarom een zeer geringe kans op coronairsclerose';

        return { coronairSclerosePercentage, indicationOutcomeText };
    }

    const ageInterval = age >= 80 ? 80 : Math.floor(age / 10) * 10;

    if (ageInterval && numberOfIndications >= 1) {
        switch (numberOfIndications) {
            case 1:
                coronairSclerosePercentage = coronairSclerosePercentages[ageInterval].aspecifiekeThorocalePijn[gender];
                break;
            case 2:
                coronairSclerosePercentage = coronairSclerosePercentages[ageInterval].atypischeAnginaPectoris[gender];
                break;
            case 3:
                coronairSclerosePercentage = coronairSclerosePercentages[ageInterval].typischeAnginaPectoris[gender];
                break;
            default:
        }
    }

    if (coronairSclerosePercentage >= 30 && coronairSclerosePercentage <= 70) {
        indicationOutcomeText = `Er is sprake van een intermediaire kans (30 - 70%) op belangrijke coronairsclerose. De kans is ${coronairSclerosePercentage}%`;
    } else if (coronairSclerosePercentage === 0) {
        indicationOutcomeText = 'De kans op belangrijke coronairsclerose is gering';
    } else {
        indicationOutcomeText = `De kans op belangrijke coronairsclerose is ${coronairSclerosePercentage}%`;
    }

    return { coronairSclerosePercentage, indicationOutcomeText };
}
